import styled from "styled-components"
import { Col } from "reactstrap"

const AudioPlayerColStyle = styled(Col)`
    padding: 0 15px;
    border-radius: 5px;
    background: ${props => props.theme.main.backgroundWhite};
`

export default AudioPlayerColStyle